import React, { ReactNode } from 'react';
import { useJoinUrl } from 'src/client/components/buttons/JoinButton';
import { TABLET_PORTRAIT, DESKTOP, XX_LARGE } from 'src/client/constants/mediaQueries';
import { logoUrl } from 'src/client/helpers/urls/logoUrl';
import { useSelector } from 'src/client/redux';
import styled from 'styled-components/macro';
import { DescriptionText, HighlightText, BrandedPillButton } from './styles';
import { ensure } from 'src/client/utils/type-utils';
import { useStaticSplashContent } from './content/useStaticSplashContent';

type Props = {
  descriptionText?: ReactNode;
  highlightText?: ReactNode;
  joinButtonText?: string;
  joinCampaign?: string;
  gridArea?: string;

  hideLogo?: boolean;
  panelNumber: string;
};

export const InfoPanel = (props: Props) => {
  const site = useSelector((state) => state.site);
  const { cdnUrl } = useSelector((state) => state.app);
  const { infoPanels } = useStaticSplashContent();
  const panelText = ensure(infoPanels[props.panelNumber]);

  const [href] = useJoinUrl({ campaign: panelText.campaign });

  return (
    <Wrapper>
      <PanelArea>
        {!props.hideLogo && <Logo src={logoUrl(cdnUrl, site)} alt={site.name} />}
        <StyledHighlightText>{panelText.highlightText}</StyledHighlightText>
        <StyledDescriptionText>{panelText.description}</StyledDescriptionText>
        <StyledButton as="a" href={href} data-tagmanager-event="join_cta">
          {panelText.buttonText}
        </StyledButton>
      </PanelArea>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  background-color: #222222;
  padding: 20px 10px;

  @media ${TABLET_PORTRAIT} {
    padding: 30px 20px;
  }

  @media ${DESKTOP} {
    padding: 40px 20px;
  }

  @media ${XX_LARGE} {
    padding: 50px 30px;
  }
`;

const PanelArea = styled.div`
  max-width: 1400px;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(3, auto);
  gap: 10px;
  justify-items: center;
  max-width: 1400px;
  margin: 0 auto;

  @media ${TABLET_PORTRAIT} {
    grid-template-columns: 1fr max-content;
  }

  @media ${DESKTOP} {
    grid-column-gap: 20px;
  }
`;

const Logo = styled.img`
  max-width: 120px;

  @media ${DESKTOP} {
    max-width: 180px;
  }
`;

const StyledHighlightText = styled(HighlightText)`
  width: 100%;

  @media ${TABLET_PORTRAIT} {
    text-align: left;
    max-width: fit-content;
    grid-row: 1 / -1;
  }

  @media ${XX_LARGE} {
    font-size: 48px;
  }
`;

const StyledDescriptionText = styled(DescriptionText)`
  max-width: 100%;
  white-space: nowrap;

  @media ${TABLET_PORTRAIT} {
    text-align: center;

    br {
      display: block;
    }
  }

  @media ${XX_LARGE} {
    font-size: 18px;
  }
`;

const StyledButton = styled(BrandedPillButton)`
  @media ${TABLET_PORTRAIT} {
    min-width: 250px;
  }
`;
